/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-parallax.js
 *
 * スクロールに合わせて実行するパララックスアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const setSlideText = () => {
	function setupSlideTextX(selector, speed, percent, direction) {
		gsap.utils.toArray(selector).forEach((element) => {
			// 要素の幅または高さを取得します
			const dimension = direction === "xPercent" ? element.getBoundingClientRect().width : element.getBoundingClientRect().height;
			// 持続時間を計算します（幅または高さ ÷ 速度）
			const duration = dimension / speed;

			const slideAnimation = gsap.to(element, {
				[direction]: percent,
				duration: duration,
				ease: "none",
				paused: true, // 初期状態ではアニメーションを一時停止
				repeat: -1, // 無限に繰り返し
			});

			ScrollTrigger.create({
				trigger: element,
				start: "top bottom", // 要素の上端がビューポートの下端に達した時
				end: "bottom top", // 要素の下端がビューポートの上端を超えた時
				onEnter: () => slideAnimation.resume(), // ビューポートに入ったらアニメーション再開
				onLeave: () => slideAnimation.pause(), // ビューポートから出たらアニメーション一時停止
				onEnterBack: () => slideAnimation.resume(), // ビューポートに戻ったら再開
				onLeaveBack: () => slideAnimation.pause(), // ビューポートから後ろ向きに出たら停止
				// markers: true, // 開発時にはマーカーを表示して確認
				toggleActions: "play none none none",
				// 上記では入場時にのみアクションを設定していますが、必要に応じて調整してください。
			});
		});
	}

	// 各要素に対してアニメーションとスクロールトリガーを設定
	setupSlideTextX(".slideTxtX", 50, -100, "xPercent");

	if (window.matchMedia("(max-width: 750px)").matches) {
		setupSlideTextX(".slideImageXsp", 50, -100, "xPercent");
		setupSlideTextX(".slideKvX", 50, -100, "xPercent");
	}
};
/**
 * 処理
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function scrollSlideText() {
	setSlideText();
}

/**
 *  Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { scrollSlideText };
